import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { ClientconfigService, TrackAndTraceService } from '../../api';

export const getTrackAndTraceByWebtoken =
  (webtoken: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new TrackAndTraceService()
      .getTrackAndTrace(webtoken)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByAbNr =
  (abnr: string, empfaengerplz: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new TrackAndTraceService()
      .getTrackAndTraceBySpedeigennrOrAbnr(abnr, empfaengerplz)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByAbNrAndEmpfaengerMatchcodeAndPLZ =
  (abnr: string, empfmatchcode: string, empfaengerplz: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new TrackAndTraceService()
      .getTrackAndTraceByAbnr(abnr, empfmatchcode, empfaengerplz)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByAbNrAndAbsenderMatchcodeAndPLZ =
  (abnr: string, absmatchcode: string, empfaengerplz: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new TrackAndTraceService()
      .getTrackAndTraceByAbNrAndAbsenderMatchcode(
        abnr,
        absmatchcode,
        empfaengerplz
      )
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByReferenz =
  (
    bexOrRef: string,
    empfaengerplz: string,
    datumvon: string | undefined,
    datumbis: string | undefined
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    new TrackAndTraceService()
      .getTrackAndTraceBySpedeigennrOrReferenz(
        bexOrRef,
        empfaengerplz,
        datumvon,
        datumbis
      )
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceBySpedeigennr =
  (bex: string, plz: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    new TrackAndTraceService()
      .getTrackAndTraceBySpedeigennr(bex, plz)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByReferenznr =
  (referenznr: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    new TrackAndTraceService()
      .getTrackAndTraceByReferenznr(referenznr)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getTrackAndTraceByMandantAndReferenzNr =
  (mandant: string, referenznr: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    new TrackAndTraceService()
      .getTrackAndTraceByMandantAndReferenzNr(mandant, referenznr)
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.GET_TRACKTRACE,
          payload: response.data,
        });
      })
      .catch((ex: { response: { data: any[] } }) => {
        if (ex.response.data[0].severity !== undefined) {
          dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: ex.response.data[0],
          });
        }
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getClientConfig =
  () =>
  (dispatch: Dispatch<ReduxAction>): void => {
    new ClientconfigService()
      .getClientConfig()
      .then((response: { data: any }) => {
        dispatch({
          type: ActionTypes.SET_CLIENT_CONFIG,
          payload: response.data,
        });
      });
  };

export const fehlermeldung =
  (fehler: string) =>
  (dispatch: Dispatch<ReduxAction>): void => {
    const msg = {
      header: 'Fehler',
      message: fehler,
    };

    dispatch({
      type: ActionTypes.SET_NOTIFICATION,
      payload: msg,
    });
  };
